import { api } from '../../lib/apiClient';

export const pricingKeys = {
  all: ['pricing'],
};

/** Public payload: `{ plans, addons }`, both pre-sorted by sort order. */
export async function getPricing() {
  const { data } = await api.get('/pricing', { skipAuth: true });
  return data;
}
